import { NavigableModal } from '$components'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { EditClientProfileForm, EditClientProfileSchema, Input } from '$features/clients/forms/edit-client-profile/index'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { clientShowOptions, clientShowQueryKey, clientUpdateMutation } from '$api-client/@tanstack/react-query.gen'
import { ToastHelper } from '$components'
import { ClientsFilterParam } from '$features/clients/enums/filter-params'

export function EditClientProfileModal() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const queryClient = useQueryClient()

  const { data } = useQuery({
    ...clientShowOptions({
      path: {
        id: Number(id),
      },
      query: {
        include_deleted: true,
        [ClientsFilterParam.IncludeUnapproved]: searchParams.get(ClientsFilterParam.IncludeUnapproved) === '1',
      },
    }),
  })

  const { mutate: updateClient, isPending: isUpdatingClient } = useMutation({
    ...clientUpdateMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: clientShowQueryKey({
          path: {
            id: Number(id),
          },
        }),
      })

      ToastHelper.success('Client profile updated successfully.')
      handleClose()
    },
    onError: () => ToastHelper.error('Failed to update client profile.'),
  })

  const handleClose = () => navigate(-1)

  const handleSubmit = async (values: EditClientProfileSchema) => {
    updateClient({
      path: {
        client: Number(id),
      },
      // @ts-expect-error - TODO: fix this
      body: values,
    })
  }

  const client = data?.data

  if (!client) {
    return null
  }

  return (
    <EditClientProfileForm
      onSubmit={handleSubmit}
      onCancel={handleClose}
      isLoading={isUpdatingClient}
      defaultValues={{
        [Input.FirstName]: client.first_name,
        [Input.LastName]: client.last_name,
      }}
    >
      <NavigableModal onClose={handleClose}>
        <NavigableModal.Header>
          <NavigableModal.Heading>
            Edit Client Profile
          </NavigableModal.Heading>
        </NavigableModal.Header>

        <NavigableModal.Content>
          <EditClientProfileForm.Content />
        </NavigableModal.Content>

        <NavigableModal.Footer>
          <EditClientProfileForm.Controls />
        </NavigableModal.Footer>
      </NavigableModal>
    </EditClientProfileForm>
  )
}
